import styled, { keyframes } from 'styled-components';

import { ANIMATION_TIMING } from '../constants';

export const TranslateLettersAnimation = keyframes`
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-100%);
  }
`;

export const Wrapper = styled.span`
  display: inline-block;
  position: absolute;
  height: 1.1em;
  overflow: hidden;
  margin-left: 0px;
  color: var(--colors-turquoise);
`;

export const Letter = styled.span`
  display: inline-block;
  white-space: pre-wrap;
  padding-bottom: 10px;
  animation: ${TranslateLettersAnimation} cubic-bezier(0.76, 0, 0.24, 1) forwards;
  animation-iteration-count: 1;
  animation-duration: ${ANIMATION_TIMING}ms;
`;

export const StyledEntry = styled.span`
  display: block;
`;

// Simulate loop to generate cumulative delay
const entriesIterationDelayStyle = Array(30)
  .fill(0)
  .reduce(
    (style, _, iteration) => `${style} ${Letter}:nth-child(${iteration}) {
      animation-delay: ${iteration * 15}ms;
    }`,
    ''
  );

export const EntriesWrapper = styled.span`
  display: inline-block;
  font-size: inherit;
  line-height: inherit;
  text-decoration: none;
  height: 100%;

  ${entriesIterationDelayStyle};
`;
